/**
 * @generated SignedSource<<701ae393984c3ec62918e5301aeed75b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$data = {
  readonly id?: string;
  readonly number: number | null | undefined;
  readonly " $fragmentType": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView";
};
export type storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$key = {
  readonly " $data"?: storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "55c809aed02a493612e0bac6df522d64";

export default node;
